import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { PATH_LOGIN, PATH_CHANGE_PASSWORD, PATH_CLIENT_LIST } from 'routing/path'
import { getCurrentUserReady, getCurrentUser } from 'store/admin-user/reducer.user-get-current'

export function useCheckPermissions() {
  const location = useLocation();
  const currentUser = useSelector(getCurrentUser);
  const currentUserReady = useSelector(getCurrentUserReady);
  
  if (!currentUserReady) {
    return null; // wait for user authorization endpoint
  }
  else if (!currentUser && location.pathname !== PATH_LOGIN) {
    return (
      <Navigate to={PATH_LOGIN} />
    )
  }
  else if (currentUser && currentUser.passwordExpired && location.pathname !== PATH_CHANGE_PASSWORD) {
    return (
      <Navigate to={PATH_CHANGE_PASSWORD} />
    )
  }
  else if (currentUser && location.pathname === PATH_LOGIN) {
    return (
      <Navigate to={PATH_CLIENT_LIST} />
    )
  }
  return null; // no redirect needed
}
